export default __webpack_public_path__ + "static/media/Devourer's Ring of the Abyss.3dc095e7.jpg";